<div class="dialog-header">
  <h2 mat-dialog-title>Editar Documento</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form [formGroup]="form" class="edit-document-form">
    <div class="form-section">
      <div class="form-row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Fecha Inicio</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="start_date" />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Fecha Fin</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="end_date" />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="form-section">
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>{{ relatedTypeLabel }}</mat-label>
            <mat-select formControlName="related_id">
              @for (relatedEntity of relatedEntities; track relatedEntity.trackBy) {
                <mat-option [value]="relatedEntity.id">
                  @if (selectedType.related_type === DocumentRelatedType.WorkingContractVariableCondition) {
                    {{ relatedEntity.start_date | date: 'dd-MM-yyyy' }}
                    @if (relatedEntity.end_date) {
                      - {{ relatedEntity.end_date | date: 'dd-MM-yyyy' }}
                    }
                  } @else if (selectedType.related_type === DocumentRelatedType.HealthInsuranceContract) {
                    {{ relatedEntity.contract_identifier }} : {{ relatedEntity.start_date | date: 'dd-MM-yyyy' }}
                    @if (relatedEntity.end_date) {
                      - {{ relatedEntity.end_date | date: 'dd-MM-yyyy' }}
                    }
                  } @else if (selectedType.related_type === DocumentRelatedType.HealthInsuranceContractCard) {
                    {{ relatedEntity.start_date | date: 'dd-MM-yyyy' }}
                    @if (relatedEntity.end_date) {
                      - {{ relatedEntity.end_date | date: 'dd-MM-yyyy' }}
                    }
                  } @else if (selectedType.related_type === DocumentRelatedType.WorkingContract) {
                    {{ relatedEntity.name }}
                  } @else if (selectedType.related_type === DocumentRelatedType.User) {
                    {{ relatedEntity.name }} {{ relatedEntity.surnames }}
                  } @else if (selectedType.related_type === DocumentRelatedType.AbsenceRequest) {
                    {{ relatedEntity.start_date | date: 'dd-MM-yyyy' }}
                    @if (relatedEntity.end_date) {
                      - {{ relatedEntity.end_date | date: 'dd-MM-yyyy' }}
                    }
                  } @else {
                    {{ relatedEntity.id }}
                  }
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="form-section">
        <div class="form-row">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Comentario</mat-label>
            <textarea matInput formControlName="comment" rows="3" maxlength="255"></textarea>
            <mat-hint>{{ form.get('comment')?.value?.length || 0 }}/255</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" (click)="save()" [disabled]="!form.valid">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>
